// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"215":"assets","9966":"dashboard"}[chunkId] || chunkId) + "." + {"215":"b577b342","6327":"b577b342","9966":"df64af23"}[chunkId] + ".chunk.css";
};